import React from "react";
import { LANDSCAPE_LAYOUT } from "./constants";
import { ArrowDownIcon, ArrowUpIcon } from "../../theme/assets";
import Discount from "./Discount";
import { renderHTML } from "../../utils/misc";

import classnames from "classnames";
import styles from "./PromotionList.scss";

export default function StatelessPromotion({
  expanded,
  toggleExpand,
  promotion,
  layout,
  currency,
  children,
  childrenClassName,
  expandedClassName,
}) {
  return (
    <div
      className={classnames("wbkv9-StatelessPromotion", "promotionContainer")}
      onClick={toggleExpand}>
      <div
        className={classnames({
          [styles.promotion]: true,
          [styles.promotionFlex]: layout === LANDSCAPE_LAYOUT,
        })}>
        <div className={classnames("wbkv9-StatelessPromotion-leftContainer", styles.leftContainer)}>
          <div className="title" dangerouslySetInnerHTML={renderHTML(promotion.get("name"))}></div>
        </div>

        <div
          className={classnames("wbkv9-StatelessPromotion-rightContainer", styles.rightContainer)}>
          <Discount promotion={promotion} layout={layout} currency={currency} />
        </div>
      </div>

      <div className={styles.arrowContainer}>
        <div className={classnames(styles.arrowDownIcon, "arrowDownIcon")}>
          {expanded ? <ArrowUpIcon /> : <ArrowDownIcon />}
        </div>
      </div>

      <div
        className={classnames({
          "wbkv9-StatelessPromotion-children": true,
          [styles.childrenContainer]: true,
          [childrenClassName]: true,
          [expandedClassName]: expanded,
        })}>
        {children}
      </div>
    </div>
  );
}
